/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

 (function($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages

				// HAMBURGER MENU
				// --------------
				$('.m-hamburger').click(function() {
					$(this).toggleClass('is-open');
				});

				// ADD DATA-VALIDATION ATTRIBUTES TO CF7 INPUT
				// -------------------------------------------
				$('.wpcf7-validates-as-required[type=text]').attr('data-validation', 'required');

				$('.wpcf7-validates-as-required[type=email]').attr('data-validation', 'email');

				$('.wpcf7-validates-as-required[type=url]').attr('data-validation', 'url');

				$('.wpcf7-validates-as-required[type=tel]').attr('data-validation', 'number');

				$('.wpcf7-validates-as-required[type=number]').attr('data-validation', 'number');

				$('.wpcf7-validates-as-required[type=date]').attr('data-validation', 'date');

				$('textarea.wpcf7-validates-as-required').attr('data-validation', 'required');

				$('select.wpcf7-validates-as-required').attr('data-validation', 'required');

				$('.wpcf7-validates-as-required input[type=checkbox]').attr('data-validation', 'required');
				$('.wpcf7-validates-as-required[type=checkbox]').attr('data-validation', 'required');

				$('.wpcf7-validates-as-required[type=file]').attr('data-validation', 'required');

				// INIT JQUERY FORM VALIDATOR
				// --------------------------
				var ita = {
					errorTitle : 'Invio della richiesta fallito',
					requiredFields : 'Campo da compilare',
					badTime : 'Non hai inserito un orario corretto',
					badEmail : 'L\'indirizzo email non è corretto',
					badTelephone : 'Non hai inserito un numero di telefono corretto',
					badSecurityAnswer : 'Non hai dato una risposta esatta alla domanda di sicurezza',
					badDate : 'Non hai inserito una data corretta',
					lengthBadStart : 'Devi inserire una risposta tra ',
					lengthBadEnd : ' caratteri',
					lengthTooLongStart : 'Non hai dato una risposta più lunga di ',
					lengthTooShortStart : 'Non hai dato una risposta più corta di ',
					notConfirmed : 'I valori non possono essere confermati',
					badDomain : 'Valore di dominio non corretto',
					badUrl : 'La tua risposta non è un URL corretto',
					badCustomVal : 'Hai dato una risposta non corretts',
					badInt : 'La risposta che hai dato non è un numero corretto',
					badSecurityNumber : 'Il tuo numero di sicurezza non è corretto',
					badUKVatAnswer : 'Numero UK VAT non corretto',
					badStrength : 'La password non è abbastanza sicura',
					badNumberOfSelectedOptionsStart : 'Devi scegliere almeno ',
					badNumberOfSelectedOptionsEnd : ' risposte',
					badAlphaNumeric : 'La risposta deve contenere solo caratteri alfanumerici ',
					badAlphaNumericExtra: ' e ',
					wrongFileSize : 'Il file che vuoi caricare è troppo grande',
					wrongFileType : 'Il file che vuoi caricare non è del tipo corretto',
					groupCheckedRangeStart : 'Scegli tra ',
					groupCheckedTooFewStart : 'Scegli almeno ',
					groupCheckedTooManyStart : 'Scegli un massimo di ',
					groupCheckedEnd : ' campo/i'
				};
				var fra = {
					requiredFields : 'Champ à compléter',
					badEmail : 'L\'adresse email n\'est pas correcte',
				};
				var deu = {
					requiredFields : 'Feld muss ausgefüllt werden',
					badEmail : 'Die E-Mail-Adresse ist nicht korrekt',
				};
				var esp = {
					requiredFields : 'Campo para completar',
					badEmail : 'La dirección de correo electrónico no es correcta',
				};

                var curr_lang = '';
				if ($('html').attr('lang') === 'it-IT') {
                    curr_lang = ita;
                }
				else if ($('html').attr('lang') === 'fr-FR') {
                    curr_lang = fra;
                }
				else if ($('html').attr('lang') === 'de-DE') {
                    curr_lang = deu;
                }
				else if ($('html').attr('lang') === 'es-ES') {
                    curr_lang = esp;
                }

                // Validazioni custom
                $('[name="figuraprofessionale[]"]').change(function(e) {
                    var count_cbs = 0;
                    $.each($('[name="figuraprofessionale[]"]:checked'), function() {
                        count_cbs++;
                    });
                    $('[name="figuraprofessionale_count"]').val(count_cbs).blur();
                });

                var cbRequiredError = {
                    'en-US': "Required field. You can make a maximum of 2 choices.",
                    'it-IT': "Campo da compilare. Puoi effettuare un massimo di 2 scelte.",
                    'fr-FR': "Champ à compléter. Vous pouvez faire un maximum de 2 choix.",
                    'de-DE': "Feld muss ausgefüllt werden. Sie können maximal 2 Optionen auswählen.",
                    'es-ES': "Campo para completar. Puedes hacer un máximo de 2 elecciones.",
                };

                $('[name="figuraprofessionale_count"]').attr('data-validation', 'cb_required_max_2');
                $.formUtils.addValidator({
                    name: 'cb_required_max_2',
                    validatorFunction: function(value, $el, config, language, $form) {
                        cbs_checked = parseInt($el.val());
                        return ! isNaN(cbs_checked) && ! (cbs_checked > 2 || cbs_checked == 0);
                    },
                    errorMessage: cbRequiredError[$('html').attr('lang')],
                    errorMessageKey: 'badCheckboxesMax2'
                });
                // Validazioni custom END

                $.validate({
                    language: curr_lang,
                    borderColorOnError : '',
                    onSuccess : function(form) {
                        //console.log("success");

                        var qs = '';
                        var thankyouURL = $(form[0]).parents('.wpcf7').next().text();
                        //console.log("thankyouURL = " + thankyouURL);

                        // Se sono nella form Contatti, leggo il destinatario e lo appendo alla querystring, per tracciarlo col Tag Manager (vedi funzione footer_scripts)
                        var dest = $(form[0]).find('[name="destinatario"]');
                        if (dest.length > 0) {
                            qs = '?dest=' + dest.val();
                        }

                        // mgigli 20220209 - Invio eventi GTM per le form (per rif. vedi commento in templates/head.php)
                        window.dataLayer = window.dataLayer || [];
                        var dataLayerData = {};
                        var formId = $(form[0]).attr('id');

                        if (formId == 'contact') {
                            dataLayerData = {
                                'event': 'submit-form-contatti-ok',
                                'country': $(form[0]).find('[name="paese"]').val(),
                                'region': $(form[0]).find('[name="regione"]').val(),
                                'destinatario': dest.val(), // dest e' gia' valorizzata sopra
                            };
                        }
                        else if (formId == 'prodotto-form') {
                            dataLayerData = {
                                'event': 'submit-form-info-prodotto-ok',
                                'clientType': $(form[0]).find('[name="azienda_val"]').val(),
                                'province': $(form[0]).find('[name="provincia"]').val(),
                                'sector': $(form[0]).find('[name="settore_val"]').val(),
                            };
                        }
                        else if (formId == 'newsletter-form') {
                            dataLayerData = {
                                'event': 'submit-form-newsletter-ok',
                            };
                        }
                        //console.log(dataLayerData, "dataLayerData");

                        window.dataLayer.push(dataLayerData);
                        // mgigli 20220209 - END

                        // mgigli 20220119
                        // Invio dei dati alla Iubenda Consent Solution
                        // Rif. https://www.iubenda.com/it/help/6530-consent-solution-documentazione-js
                        var subjectId = $(form[0]).find('[name="email"]').val().toLowerCase().replace(/\W/g, '-');
                        var formSubject = {
                            // chiavi: id, email, first_name, last_name, full_name
                            // valori: input's "name" attribute
                            email: "email", // input's "name" attribute
                        };
                        if ($(form[0]).find('[name="nomecognome"]').length > 0) formSubject.full_name = "nomecognome";
                        else if ($(form[0]).find('[name="nome"]').length > 0) formSubject.full_name = "nome";

                        //console.log(form, "form");
                        //console.log(subjectId, "subjectId");
                        //console.log(formSubject, "formSubject");

                        _iub.cons_instructions.push(["submit", {
                            writeOnLocalStorage: false,
                            form: {
                                selector: form, // oggetto o id della form
                                map: {
                                    subject: formSubject,
                                    preferences: {
                                        // opzioni libere
                                        generic: "privacy", // input's "name" attribute
                                        //newsletter: "newsletter", // input's "name" attribute
                                    }
                                }
                            },
                            consent: {
                                subject: {
                                    id: subjectId,
                                },
                                // lasciare cosi' se si usa Iubenda per creare i documenti legali
                                legal_notices: [{
                                        identifier: "privacy_policy",
                                    },
                                    {
                                        identifier: "cookie_policy",
                                    }
                                ],
                            }
                        },
                        {
                            // Sia in caso di successo che di errore di Iubenda, mando alla thankyou page / visualizzo il messaggio
                            success: function(response) {
                                //console.log(response, "iubenda success");

                                // mgigli - Doppio funzionamento:
                                // - Se l'URL inizia con / (e' davvero un'URL), mando alla thankspage
                                // - Altrimenti, stampo il contenuto e NON mando alla thankspage
                                if (thankyouURL.indexOf("/") == 0) {
                                    location.assign(thankyouURL + qs);
                                }
                                else {
                                    $(form[0]).parents('.wpcf7').next().show();
                                }
                            },
                            error: function(response) {
                                //console.log(response, "iubenda error");

                                // mgigli - Doppio funzionamento:
                                // - Se l'URL inizia con / (e' davvero un'URL), mando alla thankspage
                                // - Altrimenti, stampo il contenuto e NON mando alla thankspage
                                if (thankyouURL.indexOf("/") == 0) {
                                    location.assign(thankyouURL + qs);
                                }
                                else {
                                    $(form[0]).parents('.wpcf7').next().show();
                                }
                            }
                        }
                        ]);

                        // mgigli - Azioni da fare per le form senza thankyou page
                        /*
                        if ($(form[0]).hasClass('form-inpage')) {
                            setTimeout(function() {
                                // Evento per la form della pagina prodotto
                                dataLayer.push({'event':'GAEvent','eventCategory':'Contatti','eventAction':'Richiedi informazioni','eventLabel':undefined,'eventValue':undefined});
                            }, 500);
                        }
                        */

                        // mgigli 20220119
                        // Il redirect alla thankyou / stampa del messaggio di conferma era qua, ora e' stato spostato nelle callback di Iubenda sopra
                    },
                    onError: function(form) {
                        //console.log("error");
                        var firstErr = form.find('.has-error').first();
                        if (typeof firstErr !== "undefined" && firstErr) {
                            $('html, body').animate({
                                scrollTop: firstErr.offset().top - 120,
                            }, 0);
                        }
                        //console.log(firstErr, "firstErr");

                        // mgigli 20220209 - Invio eventi GTM per le form (per rif. vedi commento in templates/head.php)
                        window.dataLayer = window.dataLayer || [];
                        var dataLayerData = {};

                        var formId = $(form[0]).attr('id');
                        var errorField = firstErr.prev('label').text();
                        if (errorField == '') errorField = firstErr.find('label').text();
                        if (errorField == '') errorField = firstErr.parent('fieldset').find('legend').text();

                        if (formId == 'contact') {
                            dataLayerData = {
                                'event': 'submit-form-contatti-error',
                                'errorField': errorField,
                                'errorMessage': firstErr.find('.form-error').text(),
                            };
                        }
                        else if (formId == 'prodotto-form') {
                            dataLayerData = {
                                'event': 'submit-form-info-prodotto-error',
                                'errorField': errorField,
                                'errorMessage': firstErr.find('.form-error').text(),
                            };
                        }
                        else if (formId == 'newsletter-form') {
                            dataLayerData = {
                                'event': 'submit-form-newsletter-error',
                                'errorField': errorField,
                                'errorMessage': firstErr.find('.form-error').text(),
                            };
                        }
                        console.log(dataLayerData, "dataLayerData");

                        window.dataLayer.push(dataLayerData);
                        // mgigli 20220209 - END
                    },
                });

                /*
                $.validate({
                    language: ita,
                    borderColorOnError : '',
                    onSuccess : function(form) {
                        var thankyouURL = $(form[0]).parents('.wpcf7').next().text();
                        location.assign(thankyouURL);
                    },
                });
                */

				// INIT AJAXFORM ON CF7 FORMS
				// --------------------------

				$('.wpcf7-form').ajaxForm();

                /* Alternativa per errore "giaiscritto" Mailchimp
                var options = {
                    error: function(data) {
                        var dataTexts = $.parseJSON(data.responseText);
                        $('[name="_wpcf7"][value="' + dataTexts.form_wpcf7_id + '"]').parents('form').find('.wpcf7-response-output').text(dataTexts.msg).addClass('help-block form-error').css('position', 'relative').show();
                    }
                };
				$('.wpcf7-form').ajaxForm(options);
                */

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function() {
				// JavaScript to be fired on the home page
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function() {
				// JavaScript to be fired on the about us page
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
